import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import Amplify, { API, graphqlOperation } from 'aws-amplify';

import ContextProvider from '../provider/ContextProvider';
import Header from '../components/Header';
import config from '../aws-exports';
import GlobalStyle from '../styles/globalStyles';

Amplify.configure(config);

const Layout = ({ location, children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  return (
    <ContextProvider>
      <GlobalStyle />
      <Header selected={location.pathname} />
      <Container>
        <Wrapper>{children}</Wrapper>
      </Container>
    </ContextProvider>
  );
};

const Container = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  background-color: floralwhite;
  @media (max-width: 1048px) {
    width: auto;
  }
  h1 {
    text-transform: uppercase;
    font-family: Impact;
    font-weight: 400;
    font-size: 52px;
    color: black;
    line-height: 1;
  }
  p {
    font-size: 16px;
    font-weight: 300;
  }
`;

const Wrapper = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
`;

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
